export const loginBg = (value: string) => {
  localStorage.setItem('login-background', value);
};

export const getLoginBg = (): string | null => {
  return localStorage.getItem('login-background') || null;
};

export const companyId = (value: string) => {
  localStorage.setItem('company_id', value);
};

export const getCompanyId = (): string | null => {
  return localStorage.getItem('company_id') || null;
};

export const userId = (value: string) => {
  localStorage.setItem('user_id', value);
};

export const getUserId = (): string | null => {
  return localStorage.getItem('user_id') || null;
};

export const stripeCustomerId = (value: string) => {
  localStorage.setItem('stripe_customer_id', value);
};

export const getStripeCustomerId = (): string | null => {
  return localStorage.getItem('stripe_customer_id') || null;
};

export const removeUser = (): string | null => {
  localStorage.removeItem('user_id');
  localStorage.removeItem('stripe_customer_id');
  return null;
}